import { createListReducer } from '../../../common/services/reducerCreator';

export default createListReducer('MATCHES', ['next', 'highlighted', 'future']);
